import type { GraphQLError } from 'graphql';

import { expValEquals } from '@confluence/feature-experiments';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import type { ContentStatus } from '../constants/ContentStatus.ts';
import useContentClassificationContentDataClassificationQuery, {
	type useContentClassificationContentDataClassificationQuery$data,
	type useContentClassificationContentDataClassificationQuery$variables,
} from '../hooks/__generated__/useContentClassificationContentDataClassificationQuery.graphql.ts';
import useContentClassificationV2ContentDataClassificationQuery, {
	type useContentClassificationV2ContentDataClassificationQuery$data,
	type useContentClassificationV2ContentDataClassificationQuery$variables,
} from '../hooks/__generated__/useContentClassificationV2ContentDataClassificationQuery.graphql.ts';
import { getQuerySingleContentStatusArrayVariable } from '../utils/getQuerySingleContentStatusArrayVariable.ts';

export function preloadContentDataClassification(
	contentId: string,
	contentStatus: ContentStatus,
): Promise<{
	data:
		| useContentClassificationContentDataClassificationQuery$data
		| useContentClassificationV2ContentDataClassificationQuery$data
		| null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	const variables = {
		contentId,
		lowerCaseContentStatusArray: getQuerySingleContentStatusArrayVariable([contentStatus]),
	};
	if (expValEquals('confluence_classification_level_v2', 'isEnabled', true)) {
		return query<
			useContentClassificationV2ContentDataClassificationQuery$data,
			useContentClassificationV2ContentDataClassificationQuery$variables
		>({
			query: useContentClassificationV2ContentDataClassificationQuery,
			variables,
		});
	}

	return query<
		useContentClassificationContentDataClassificationQuery$data,
		useContentClassificationContentDataClassificationQuery$variables
	>({
		query: useContentClassificationContentDataClassificationQuery,
		variables,
	});
}
